import { gql } from "@apollo/client";

const getCoachingReportQuery = gql`
  query getCoachingReport($subjectId: Int!, $managerId: Int!) {
    coachingReport(subjectId: $subjectId, managerId: $managerId) {
      id
      reportStartDate
      reportEndDate
      created
      meta {
        manager {
          name
          firstName
        }
        report {
          name
          firstName
          role
          tenure
        }
        period {
          start
          end
        }
        generated
        dataCounts {
          meetings
          workSummaries
          goals
          checkins
          recognitions
        }
      }
      dashboard {
        dimension
        status
        statusLabel
        detail
      }
      sources {
        type
        title
        sourceRef
        sourceUrl
      }
      dimensions {
        name
        status
        insights {
          title
          priority
          body
          evidence {
            text
            sourceRef
            sourceUrl
          }
          action {
            label
            text
            variant
          }
        }
      }
      agenda {
        nextMeeting {
          topic
          tags
          opener
        }
        phasedPlan {
          meeting
          theme
          topics
        }
      }
    }
  }
`;

export default getCoachingReportQuery;
